import AngleDown from '@gef-ui/material-icons/AngleDown';
import AngleUp from '@gef-ui/material-icons/AngleUp';
import { useRouter } from '@gef-ui/router-core';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import PropTypes from 'prop-types';
import rejectNil from "ramda-extension/es/rejectNil";
import React, { useEffect, useMemo, useState } from 'react';
import { useDefaultComponentValue } from '../../utils';
import SidebarMenuItem from '../SidebarMenuItem';
import { SubmenuProvider, useRegisterPaths, useSubmenuContext } from '../submenuContext';
const ICON_WIDTH = 16;
const COMPONENT_NAME = 'SidebarSubmenu';
const angleSx = {
    width: ICON_WIDTH,
    height: 16,
    ml: 1,
    position: {
        md: 'absolute',
        xl: 'static'
    },
    right: {
        md: -15,
        xl: 'auto'
    }
};
const SidebarSubmenu = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { icon, title, menuNode, children, collapseInactive, expandActive = true, ...other } = props;
    const [open, setOpen] = useState(false);
    const { paths } = useSubmenuContext();
    const { pathname } = useRouter().useLocation();
    const anySubActive = paths.some((path)=>path === pathname);
    const childrenPaths = useMemo(()=>rejectNil(React.Children.map(children, (child)=>{
            const to = child?.props?.to;
            const href = child?.props?.href;
            return to ?? href;
        })), [
        children
    ]);
    useRegisterPaths(childrenPaths);
    useEffect(()=>{
        if (anySubActive && expandActive) {
            setOpen(true);
        } else if (!anySubActive && collapseInactive) {
            setOpen(false);
        }
    }, [
        anySubActive,
        expandActive,
        collapseInactive
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SidebarMenuItem, {
        active: anySubActive,
        icon: icon,
        title: title,
        onClick: ()=>setOpen(!open),
        ...other
    }, menuNode, open ? /*#__PURE__*/ React.createElement(AngleUp, {
        sx: angleSx
    }) : /*#__PURE__*/ React.createElement(AngleDown, {
        sx: angleSx
    })), /*#__PURE__*/ React.createElement(Collapse, {
        in: open,
        timeout: "auto",
        unmountOnExit: true
    }, /*#__PURE__*/ React.createElement(List, {
        component: "div",
        disablePadding: true
    }, children)));
};
SidebarSubmenu.propTypes = {
    badgeCount: PropTypes.number,
    children: PropTypes.node,
    collapseInactive: PropTypes.bool,
    expandActive: PropTypes.bool,
    icon: PropTypes.node,
    menuNode: PropTypes.node,
    title: PropTypes.string
};
const SidebarSubmenuWrapper = (props)=>/*#__PURE__*/ React.createElement(SubmenuProvider, null, /*#__PURE__*/ React.createElement(SidebarSubmenu, props));
export default SidebarSubmenuWrapper;
